const toggleNavElement = document.querySelector('.a-toggle-nav');
const listElement = document.querySelector('.o-main-nav__list');

if (toggleNavElement && listElement) {
  toggleNavElement.addEventListener('click', () => {
    const currentState = toggleNavElement.getAttribute('aria-expanded');
    toggleNavElement.setAttribute('aria-expanded', currentState === 'true' ? 'false' : 'true');
  });
}
